<template>
<v-dialog v-model="dialog" width="900px">
  <v-card>
    <p class=".title ma-2">Chat functionality</p>
    <v-card-text>
        <div id="ysa-chat-container"></div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      firstname: "",
      lastname: "",
      huov_code: "",
      email: "",
      language: "",
      huov: {},
      telephone: "",
      chatScriptLoaded: false
    }
  },
  methods: {
    open(huov_encrid, firstname, lastname, huov_code, email, telephone, language){
        this.huov_encrid = huov_encrid;
        this.firstname = firstname;
        this.lastname = lastname;
        this.email = email;
        this.language = language;
        this.telephone = telephone;
        this.huov_code = huov_code;
        // this.dialog = true;
        // Load chat script when dialog opens
        this.$nextTick(() => {
          this.loadChatScript();
        });
    },
    
    loadChatScript() {
      // Prevent loading script multiple times
      if (this.chatScriptLoaded) {
        this.initializeChat();
        return;
      }
      
      const customParameters = [
        { firstname: this.firstname },
        { lastname: this.lastname },
        { email: this.email },
        { telephone: this.telephone },
        { bookingscode: this.huov_code },
        { bookingsnumber: this.huov_encrid }
      ];

      console.log('parameters Evy', customParameters);

      const thread_reference = customParameters.find(param => param.bookingsnumber)?.bookingsnumber || '';
      
      const script = document.createElement('script');
      script.defer = true;

      // console.log('taalcode', this.language)

      switch(this.language) {
        case 'DE':
          script.src = `https://app.youshouldask.ai/chat/js/wf9sTB/brHmOY?customParameters=${encodeURIComponent(JSON.stringify(customParameters))}&thread_reference=${encodeURIComponent(thread_reference)}`;
          break;
        case 'FR':
          script.src = `https://app.youshouldask.ai/chat/js/wf9sTB/zXYyW9?customParameters=${encodeURIComponent(JSON.stringify(customParameters))}&thread_reference=${encodeURIComponent(thread_reference)}`;
          break;
        case 'NL':
          script.src = `https://app.youshouldask.ai/chat/js/wf9sTB/4VXniO?customParameters=${encodeURIComponent(JSON.stringify(customParameters))}&thread_reference=${encodeURIComponent(thread_reference)}`;
          break;
        default:
          script.src = `https://app.youshouldask.ai/chat/js/wf9sTB/U8HIbI?customParameters=${encodeURIComponent(JSON.stringify(customParameters))}&thread_reference=${encodeURIComponent(thread_reference)}`;
      }

      // console.log('script.src', script.src);

      // script.src = `https://app.youshouldask.ai/chat/js/wf9sTB/4VXniO?customParameters=${encodeURIComponent(JSON.stringify(customParameters))}&thread_reference=${encodeURIComponent(thread_reference)}`;
      // script.src = `https://app.youshouldask.ai/chat/js/wf9sTB/4VXniO?customParameters=${encodeURIComponent(JSON.stringify(customParameters))}`;
      
      script.onload = () => {
        this.chatScriptLoaded = true;
        this.initializeChat();
        console.log("chat script loaded:",customParameters);
      };
      
      document.body.appendChild(script);
    },
    
    initializeChat() {
      // Wait 1 second before sending initial message
      
      setTimeout(() => {
        if (typeof window.ysa_sendMessage === 'function') {
          window.ysa_sendMessage("{get_info}");
        }
      }, 1000);
      
    }
  },
  
  beforeUnmount() {
    // Clean up: remove chat script if needed
    this.chatScriptLoaded = false;
  }
}
</script>

